export default __webpack_public_path__ + "static/media/doctor.8f354fdb.png";